module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/vocabulary/components/relationship-type-input.component.scss
// module id = ./src/app/vocabulary/components/relationship-type-input.component.scss
// module chunks = main